import React from 'react';
import {isPendingWalletStatus, displayBOAButton} from '../../../utils/PayoutUtils';
import {PayoutAccountTypes} from '../../../../shared/types';
import {HyperWallet, OfflinePayment, BOAPayment} from '../components';
import {PayoutState} from '../../../reducers/payout';
import {useDispatch} from 'react-redux';
import payoutActions from '../../../actions/payout.actions';

export interface PayoutSectionProps {
    messages: Record<string, string>;
    taxState: any;
    configState: any;
    payoutState: PayoutState;
}

const PayoutSection: React.FC<PayoutSectionProps> = ({
    messages,
    taxState,
    configState,
    payoutState
}) => {
    const dispatch = useDispatch();
    const {payoutProviderType, isConsent, accountStatus} = taxState || {};

    if (payoutProviderType === PayoutAccountTypes.OFFLINE) {
        return <OfflinePayment payoutState={payoutState} messages={messages} />;
    }

    if (payoutProviderType === PayoutAccountTypes.BOA && displayBOAButton(accountStatus)) {
        return <BOAPayment accountStatus={accountStatus} configState={configState} />;
    }

    if (isConsent && isPendingWalletStatus(accountStatus)) {
        return (
            <HyperWallet
                key="HWSection"
                traceSecurityLink={() => dispatch(payoutActions.traceSecurityLink())}
                taxState={taxState}
                configState={configState}
            />
        );
    }

    return null;
};

export default PayoutSection;
